import { Inbox } from "lucide-react";

export const EmptyState = ({ icon: Icon = Inbox, title, description, action }) => (
  <div
    data-testid="empty-state"
    className="flex flex-col items-center justify-center rounded-xl border border-dashed border-border bg-card/50 px-6 py-16 text-center"
  >
    <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-primary/10 text-primary">
      <Icon className="h-7 w-7" strokeWidth={1.5} />
    </div>
    <h3 className="font-heading text-lg font-semibold text-foreground">{title}</h3>
    {description && <p className="mt-1 max-w-sm text-sm text-muted-foreground">{description}</p>}
    {action && <div className="mt-5">{action}</div>}
  </div>
);

export default EmptyState;
